import React from 'react'
import styles from './EdofSection8.module.css'
const features = [
  {
    icon: "/svg/corneal-permanence.svg",
    text: "Prolongs comfortable wearing time",
  },
  {
    icon: "/svg/tolerability.svg",
    text: "Improves comfort + wearability",
  },
  {
    icon: "/svg/Reduces-friction.svg",
    text: "Reduces friction",
  },
  {
    icon: "/svg/tear volume.svg",
    text: "Supports tear volume",
  },
  {
    icon: "/svg/tear-film.svg",
    text: "Supports the tear film",
  },
  {
    icon: "/svg/re-epithelialization.svg",
    text: "Improves lubrication",
  },
];

const EdofSection8 = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        {features.map((item, index) => (
          <div key={index} className={styles.card}>
            <img src={item.icon} alt="icon" className={styles.icon} loading="lazy" decoding="async" />
            <p className={styles.text}>{item.text}</p>
          </div>
        ))}
      </div>
      <div className={styles.contentDiv}>
        <div className={styles.TextInnerDiv}>
          <h1>Comfort,<br />
            inside and out</h1>
          <h3>FusionTechnology™ inside</h3>
          <p>All Deseyne® EDOF lenses <span>contain natural supplements HA (Hyaluronic Acid) + TSP® (Tamarind Seed Polysaccharide). TSP® + HA</span> work synergistically to support hydration.</p>

        </div>

        <div className={styles.bottomBar}>
          <img src='/svg/Ha+tsp.svg' alt='Ha+tsp' loading="lazy" decoding="async" />
          <img src='/svg/white_print.svg' alt='white_print' loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
  )
}

export default EdofSection8
